import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <section className="py-20 px-4 bg-[#0f182e]" data-id="element-162">
      <div className="max-w-6xl mx-auto" data-id="element-163">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-164">
          {/* Is For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-165">
            <h3 className="text-2xl font-serif text-cream border-b border-emerald-500/30 pb-4" data-id="element-166">
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-167">
              {['Eres mamá latina en USA, 25–40, con 1+ hijos', 'Estás agotada y necesitas un plan que funcione en una casa real', 'Quieres una forma gentil (sin dejar llorar solo)', 'Quieres estructura, no teoría'].map((item, i) => <li key={i} className="flex items-start" data-id="element-168">
                  <div className="bg-emerald-900/30 p-1 rounded-full mr-3 mt-1" data-id="element-169">
                    <Check className="w-4 h-4 text-emerald-400" data-id="element-170" />
                  </div>
                  <span className="text-amber-100/80 text-lg" data-id="element-171">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Is NOT For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-172">
            <h3 className="text-2xl font-serif text-cream border-b border-rose-500/30 pb-4" data-id="element-173">
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-174">
              {["Buscas una promesa médica o 'cero despertares garantizados'", 'Quieres cambiar todo sin sostener consistencia 7 noches', 'Quieres que alguien lo haga por ti sin mover nada en tu rutina'].map((item, i) => <li key={i} className="flex items-start" data-id="element-175">
                  <div className="bg-rose-900/30 p-1 rounded-full mr-3 mt-1" data-id="element-176">
                    <X className="w-4 h-4 text-rose-400" data-id="element-177" />
                  </div>
                  <span className="text-amber-100/80 text-lg" data-id="element-178">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}